import { WithStyles } from '@material-ui/core';
import { InputLabelProps } from '@material-ui/core/InputLabel';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import * as React from 'react';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		cssFocused: {},
		cssLabel: {
			'&$cssFocused': {
				color: `${theme.palette.primary.light}} !important`,
			},
			color: theme.palette.primary.light,
		},
		cssUnderline: {
			'&:after': {
				borderBottomColor: theme.palette.primary.light,
			},
			'&:before': {
				borderBottomColor: theme.palette.primary.light,
			},
			'&:hover:not($disabled):not($focused):not($error):before': {
				borderBottomColor: `${theme.palette.primary.main} !important`,
			},
		},
	});

/**
 * ユーザ情報TextFieldフォーム
 * @param myProps
 */
const ProfileTextField: React.FC<
	TextFieldProps & WithStyles<typeof styles>
> = myProps => {
	const textFieldProps = { ...myProps };
	const classes = myProps.classes;

	if (!textFieldProps.disabled) {
		// 編集用ラベルプロパティ
		textFieldProps.InputLabelProps = {
			FormLabelClasses: {
				focused: classes.cssFocused,
				root: classes.cssLabel,
			},
		} as InputLabelProps;
		// 編集用入力フォームプロパティ
		textFieldProps.InputProps = {
			classes: {
				underline: classes.cssUnderline,
			},
		};
	} else if (!textFieldProps.helperText) {
		textFieldProps.helperText = i18n.t('ProfileTextField_0001');
	}

	if (myProps.margin === undefined) {
		textFieldProps.margin = 'normal';
	}
	if (myProps.fullWidth === undefined) {
		textFieldProps.fullWidth = true;
	}

	return <TextField {...textFieldProps} />;
};

export default withStyles(styles)(ProfileTextField) as React.ComponentType<
	TextFieldProps
>;



// WEBPACK FOOTER //
// ./src/components/ProfileTextField.tsx